module.exports = __webpack_public_path__ + "img/843.7f671aaa.png";